<template>
    <div class="report-page">
        <el-card shadow="never" class="report-card">
            <template #header>
                <div class="page-header">
                    <div>
                        <div class="page-title">{{ pageTitle }}</div>
                        <div class="page-subtitle">{{ pageSubtitle }}</div>
                    </div>
                    <div class="header-actions" v-if="!routeReportId">
                        <el-radio-group v-model="mode" size="small" @change="refreshFrame">
                            <el-radio-button label="designer">设计器</el-radio-button>
                            <el-radio-button label="viewer">预览</el-radio-button>
                        </el-radio-group>
                        <el-button size="small" @click="refreshFrame">刷新</el-button>
                    </div>
                </div>
            </template>

            <div class="toolbar" v-if="mode === 'viewer' && !routeReportId">
                <el-input v-model="reportId" clearable placeholder="输入积木报表ID" @keyup.enter="refreshFrame">
                    <template #prepend>报表ID</template>
                </el-input>
                <el-button type="primary" @click="refreshFrame">打开报表</el-button>
            </div>

            <iframe :key="frameKey" class="report-frame" :src="frameSrc" frameborder="0"></iframe>
        </el-card>
    </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const routeReportId = computed(() => String(route.params.reportId || ""));
const mode = ref(routeReportId.value ? "viewer" : "designer");
const reportId = ref(routeReportId.value);
const frameKey = ref(0);
const reportBaseUrl = (process.env.VUE_APP_BASEURL || window.location.origin).replace(/\/$/, "");

const token = computed(() => encodeURIComponent(localStorage.getItem("token") || ""));
const currentReportId = computed(() => routeReportId.value || reportId.value);
const pageTitle = computed(() => route.meta?.title || (routeReportId.value ? "业务报表" : "报表管理"));
const pageSubtitle = computed(() => routeReportId.value ? "" : "设计报表使用设计器；业务展示建议使用单报表预览地址");
const frameSrc = computed(() => {
    if (mode.value === "viewer" && currentReportId.value) {
        return `${reportBaseUrl}/jmreport/view/${encodeURIComponent(currentReportId.value)}?token=${token.value}`;
    }
    return `${reportBaseUrl}/jmreport/list?token=${token.value}`;
});

watch(routeReportId, (value) => {
    if (value) {
        reportId.value = value;
        mode.value = "viewer";
    } else {
        mode.value = "designer";
    }
    refreshFrame();
});

function refreshFrame() {
    frameKey.value += 1;
}
</script>

<style lang="scss" scoped>
.report-page {
    padding: 16px;
}

.report-card {
    border-radius: 6px;
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
}

.page-subtitle {
    margin-top: 4px;
    font-size: 12px;
    color: #8a94a6;
}

.header-actions,
.toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
}

.toolbar {
    margin-bottom: 12px;
}

.report-frame {
    display: block;
    width: 100%;
    height: calc(100vh - 172px);
    background: #fff;
}
</style>